import { render, staticRenderFns } from "./selectAddress.vue?vue&type=template&id=5f7085f6&scoped=true"
import script from "./selectAddress.vue?vue&type=script&lang=js"
export * from "./selectAddress.vue?vue&type=script&lang=js"
import style0 from "./selectAddress.vue?vue&type=style&index=0&id=5f7085f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7085f6",
  null
  
)

export default component.exports